module.exports = __webpack_public_path__ + "static/media/closing time.96ed7c96.mp3";